import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { FormattedNumber } from '@10xLabs/react-web/components/FormattedNumber'
import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { GrossIcon } from '@10xLabs/react-web/components/Icons/Gross'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { TicketIcon } from '@10xLabs/react-web/components/Icons/Ticket'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { CashIcon } from '@10xLabs/react-web/components/Icons/Cash'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { CardIcon } from '@10xLabs/react-web/components/Icons/Card'
import { device } from 'utils/style'

const Summary = styled.div<TSFixMe>`
  padding: 20px;
  border-radius: 8px;
  background-color: #1976d2;
  background-image: linear-gradient(173deg, #7130ff -11%, #1976d2 65%);
  color: #ffffff;
`

const Split = styled.div<TSFixMe>`
  display: none;

  @media ${device.laptop} {
    display: block;
    width: 1px;
    min-width: 1px;
    height: auto;
    opacity: 0.3;
    background-color: #ffffff;
  }
`

const Indicators = styled.div<TSFixMe>`
  @media ${device.laptop} {
    display: flex;
    justify-content: space-around;
  }
`

const Indicator = styled.div<TSFixMe>`
  margin: 0 0 20px;

  &:last-child {
    margin: 0;
  }

  @media ${device.laptop} {
    margin: 0 10px;

    &:first-child {
      margin: 0 10px 0 0;
    }

    &:last-child {
      margin: 0 0 0 10px;
    }
  }
`

const Label = styled.div<TSFixMe>`
  text-transform: uppercase;
  margin-bottom: 10px;
  white-space: nowrap;

  @media ${device.laptop} {
    margin-bottom: 20px;
  }
`

const Value = styled.div<TSFixMe>`
  font-size: 30px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  @media ${device.laptop} {
    margin-bottom: 0;
  }
`

const PrimaryLabel = styled(Label)<TSFixMe>`
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 1.33px;
`

const PrimaryValue = styled(Value)<TSFixMe>`
  color: #20e0a5;
`

const IndicatorIcon = styled.div<TSFixMe>`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const PrimaryIndicatorIcon = styled(IndicatorIcon)<TSFixMe>`
  background-color: #20e0a5;
`

const SecondaryLabel = styled(Label)<TSFixMe>`
  font-size: 12px;

  @media ${device.laptop} {
    margin-bottom: 25px;
  }
`

const SecondaryValue = styled(Value)<TSFixMe>`
  color: #87e7fe;
`

const SecondaryIndicatorIcon = styled(IndicatorIcon)<TSFixMe>`
  background-color: #26c8f0;
`

export const DashboardSummary = ({ sales }: TSFixMe): TSFixMe => {
  return (
    <Summary>
      <Indicators>
        <Indicator>
          <PrimaryLabel>
            <FormattedMessage id="sites.dashboard.grossSales" defaultMessage="Gross sales" />
          </PrimaryLabel>

          <PrimaryValue>
            <PrimaryIndicatorIcon>
              <GrossIcon />
            </PrimaryIndicatorIcon>

            <div>
              <FormattedPrice value={sales.total.amount} />
            </div>
          </PrimaryValue>
        </Indicator>

        <Split />

        <Indicator>
          <PrimaryLabel>
            <FormattedMessage id="sites.dashboard.totalSales" defaultMessage="Number of sales" />
          </PrimaryLabel>

          <PrimaryValue>
            <PrimaryIndicatorIcon>
              <TicketIcon />
            </PrimaryIndicatorIcon>

            <div>
              <FormattedNumber value={sales.total.count} />
            </div>
          </PrimaryValue>
        </Indicator>

        <Indicator>
          <SecondaryLabel>
            <FormattedMessage id="dictionary.cash" defaultMessage="Cash" />
          </SecondaryLabel>

          <SecondaryValue>
            <SecondaryIndicatorIcon>
              <CashIcon />
            </SecondaryIndicatorIcon>

            <div>
              <FormattedPrice value={sales.cash.amount} />
            </div>
          </SecondaryValue>
        </Indicator>

        <Indicator>
          <SecondaryLabel>
            <FormattedMessage id="dictionary.card" defaultMessage="Card" />
          </SecondaryLabel>

          <SecondaryValue>
            <SecondaryIndicatorIcon>
              <CardIcon />
            </SecondaryIndicatorIcon>

            <div>
              <FormattedPrice value={sales.card.amount} />
            </div>
          </SecondaryValue>
        </Indicator>
      </Indicators>
    </Summary>
  )
}
